import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { userStore } from '../store/userStore';



const PerfilPermissionRouteArea = () => {
  const [permission, setPermission] = useState(null);
const getUserPermissions = userStore((state) => state.getUser);

async function getIdUser() {
  const userPermissions = await getUserPermissions();
  if(userPermissions.roles[0].perfilnome === "Administrador" || userPermissions.roles[0].perfilnome === "Gerente" ){
    setPermission(true)
  }
  else{
    setPermission(false)
  }
  // setAuth(userPermissions.roles[0].perfilnome);
  // User.current = userPermissions;
}
  useEffect(() => {
    getIdUser()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line no-nested-ternary
  return permission === null ? <> </> : permission  ? <Outlet /> : <Navigate to="/" />;
};

export default PerfilPermissionRouteArea;
